module.exports = __webpack_public_path__ + "media/fonts/OpenSans-Bold-c790f99966352c531503674ee0f6be9c.ttf";